import { Component, OnInit,  Input, Output, EventEmitter } from '@angular/core';
import { GrupoFamiliar } from './grupo-familiar';
import { Estudo } from '../estudo/estudo';
import { GrupoFamiliarService } from './grupo-familiar.service';
import { MatSnackBar } from '@angular/material';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { Resposta } from 'unb-questionario-componente';
import { Questionario } from 'unb-questionario-componente';
import { EstudoService } from '../estudo/estudo.service';
import { SituacaoEnum } from '../util/situacao.enum';
import { EstudoQuestionario } from '../estudo/estudo-questionario';
import { EstudoQuestionarioEnum} from  '../util/estudo-questionario.enum';
import { ConfirmacaoDialog } from '../util/confirmacao.dialog';
import { Confirmacao } from '../util/confirmacao';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  templateUrl: './grupo-familiar-detail.component.html',
	selector: 'grupo-familiar-detail',
})


export class GrupoFamiliarDetailComponent implements OnInit {
    @Input() estudo : Estudo;
    @Input() ehAluno : boolean;
    @Input() mostrarMensagemInicial: boolean = true;
    @Output() questionarioGrupoEmitido: EventEmitter<Questionario> = new EventEmitter<Questionario>();
    // outputs usado pela validacao
    @Input() botaoSelecionarPergunta: boolean = false;
    @Output() perguntaSelecionadaEmitida: EventEmitter<number> = new EventEmitter<number>();
    @Output() membroExcluidoEmitido: EventEmitter<number> = new EventEmitter<number>();
    @Output() rowSelecionadaEmitida: EventEmitter<GrupoFamiliar> = new EventEmitter<GrupoFamiliar>();
    @Output() proximoEmitido: EventEmitter<number> = new EventEmitter<number>();
    @Output() anteriorEmitido: EventEmitter<number> = new EventEmitter<number>();

    private lista : GrupoFamiliar[];
    @Input() mostrarSalvar: boolean = true;
    @Input() mostrarExcluir: boolean= true;
    @Input() mostrarNovo: boolean= true;
    private mostrarQuestionario: boolean = false;
    private resposta: Resposta;
    private classProximo: string;
    private quantidadeMembros: number;
    private novoEmmiter:boolean = false; // controla o emiter lah do questionario
    private questionarioCorrecao: EstudoQuestionario; // essa variavel eh usada para quando a SituacaoEnum=Correcao


    private mensagemErroInicial: boolean;
    private mensagemTela: string;

    private isLoading: boolean;
    // mantém o questionario montado na memória pra nao ser necessário carregar toda hora
    private questionarioCompleto:Questionario;

    constructor(private grupoFamiliarService: GrupoFamiliarService,
      private mensagem: MatSnackBar,
      private respostaService: RespostaListaDinamicaService,
      private estudoService: EstudoService,
      public dialog: MatDialog)  {
    }

    ngOnInit() {
      if(this.estudo && this.estudo.respostaQuestionarioDadosPessoais){
        // aki tenho que ver se a respostaQuestionarioDadosPessoais foi concluida
          this.isLoading = true;
          this.respostaService.getRespostaPorId(this.estudo.respostaQuestionarioDadosPessoais).subscribe((resposta:Resposta) =>{
            if(resposta.situacao == 1){ // 1 eh NaoConcluido.
                this.mensagemErroInicial = true;
                this.isLoading = false;
                this.mensagemTela = "Primeiro você deve 'Salvar e Concluir' os formulários da aba '3.Dados Pessoais'";
                this.mostrarSalvar = false;
                this.mostrarExcluir= false;
                this.mostrarNovo = false;
            }else{
                this.carregaPerguntaQtdMembros();
            }
          },
          error => this.erro(error)
        );
      }else{
        this.mensagemTela = "Primeiro você deve 'Salvar e Concluir' os formulários da aba '3.Dados Pessoais'";
        this.mostrarSalvar = false;
        this.mostrarExcluir= false;
      }
    }

    private carregaPerguntaQtdMembros(){
      this.isLoading= true;
      this.respostaService.getRespostaPorNomeUnico(this.estudo.respostaQuestionarioDadosPessoais, "socioeconomico_qtd_membros").subscribe(
        (resultQtd: string)=>{
          if(this.mostrarMensagemInicial){
            this.quantidadeMembros = parseInt(resultQtd);
            if (resultQtd == "0"){
              this.mensagemTela = "Você não precisa cadastrar membros do grupo familiar. Clique em 'Próximo' para prosseguir.";
            }else if(resultQtd == "1"){
              this.mensagemTela = "Você deve cadastrar " + resultQtd + " membro do grupo familiar. Para isso, clique no botão Novo e preencha o formulário.";
            }else{
              this.mensagemTela = "Você deve cadastrar " + resultQtd + " membros do grupo familiar. Para isso, clique no botão Novo e preencha o formulário.";
            }
          }
          this.carregaQuestionario();
        },
        error => this.erro(error)
      );
    }


  private carregaQuestionario(): void{
    // vejo se a classe pai jah tem o questionario Preliminar preenchido.
    if(this.estudo.questionarioGrupoFamiliar){
      this.carregaQuestionarioPeloPai();
    }else{ // se nao tiver, entao carrego ele aki em baixo.
      this.carregaQuestionarioPeloServico();
    }
  }

  private carregaQuestionarioPeloPai(): void{
    this.questionarioCompleto = this.estudo.questionarioGrupoFamiliar;
    this.controlaBotaoSalvar();
  }

  private carregaQuestionarioPeloServico(): void{
    this.estudoService.getQuestionario(null, this.estudo.id, EstudoQuestionarioEnum.grupoFamiliar)
      .subscribe((result: EstudoQuestionario) =>{
        // atencao, essa lista soh vem preenchida se o status for Para Correcao.
        // No resto, ela eh preenchida dinamicamente.
        // somente aluno tem essa restricao, adm pode ver todos
        if(this.estudo.situacao == SituacaoEnum.ParaCorrecao && this.ehAluno){
          this.questionarioCorrecao = result;
        }else{
          this.questionarioCompleto = result.questionario;
          // emito o questionario montado pra classe pai. Assim, nao vou precisar carregar esse metodo novamente
          this.questionarioGrupoEmitido.emit(result.questionario);
        }
        this.controlaBotaoSalvar();

    },
    error =>  this.erro(error));
  }

  private controlaBotaoSalvar(): void{
    this.mostrarSalvar = this.estudoService.controlaBotaoSalvar(this.estudo.situacao , this.ehAluno);
    // aki faco uma validacao pra nao deixar quem tem 0 membros cadastrar
    if(this.quantidadeMembros == 0){
      this.mostrarSalvar = false;
    }
    this.mostrarExcluir= this.mostrarSalvar;
      this.carregaRespostas();

  }

  private carregaRespostas(): void{
    this.isLoading= true;
    let filtro: GrupoFamiliar = new GrupoFamiliar;
    filtro.codigoEstudoSocioEconomico = this.estudo.id;
    if(this.estudo.situacao == SituacaoEnum.ParaCorrecao && this.ehAluno){
      this.lista = this.questionarioCorrecao.listaGrupo;
      this.isLoading= false;
      this.classProximo = "";
      this.mensagemTela = null;
      this.mostrarNovo = false;
      this.mostrarExcluir = false;

    }else{
      this.grupoFamiliarService.filtrar(filtro).subscribe(
      (result:GrupoFamiliar[]) => {
          this.lista = result;
          if(this.lista.length == this.quantidadeMembros){
            this.classProximo = "";
          }else{
            this.classProximo = "disabled";
          }
          this.isLoading= false;
      },
      error => this.erro(error));
    }
  }



  private novoRecebido():void{
    this.resposta = new Resposta();
    this.novoEmmiter = true;
    this.mostrarQuestionario = true;
  }

  private respostaEmitido(event: number): void{
    let grupoFamiliar: GrupoFamiliar = new GrupoFamiliar();
    grupoFamiliar.codigoEstudoSocioEconomico = this.estudo.id;
    grupoFamiliar.respostaQuestionarioGrupoFamiliar = event;

    // aki, tenho que achar o id emitido na minha lista
    this.isLoading=true;
    this.grupoFamiliarService.update(grupoFamiliar).subscribe(
      (result:GrupoFamiliar) => {
        this.carregaRespostas();
        this.mostrarQuestionario = false;
      },
      error => this.erro(error),
      () => this.finaliza()
    );
  }

  private editarRecebido(grupoFamiliar: GrupoFamiliar): void {
    // carrego a respostaEmitida
    this.isLoading= true;
    this.mostrarQuestionario = false; // faco isso pra forcar o update do componente
    this.novoEmmiter = false;
    this.rowSelecionadaEmitida.emit(grupoFamiliar); // emito lah pro componente do validacao

    // aki tem duas ocasioes, se for uma validaao, entao carrega a resposta do
    if(this.estudo.situacao == SituacaoEnum.ParaCorrecao && this.ehAluno){
      // aki, tenho que achar o index do grupo familiar selecionado no questionarioCorrecao
      let indexGrupo = this.questionarioCorrecao.listaGrupo.findIndex(grupoCorrecao => grupoCorrecao.id ==  grupoFamiliar.id);
      this.questionarioCompleto = this.questionarioCorrecao.listaQuestionarioGrupo[indexGrupo];
      this.resposta = this.questionarioCorrecao.listaRespostaGrupo[indexGrupo];
      // faco isso pra forcar o update do componente.
      // o certo era fazer com o @ViewChild. Se der tempo, implementar depois.
      setTimeout(() => {
         this.mostrarQuestionario = true;
         this.isLoading= false;
       }, 50)

    }else{

      this.respostaService.getRespostaCompletaPorPergunta(grupoFamiliar.respostaQuestionarioGrupoFamiliar).subscribe(
        (result:Resposta) =>{
          this.resposta = result;
          this.carregaRespostas();
          this.mostrarQuestionario = true;

        },
        error =>  this.erro(error)
      );
    }
  }

  private perguntaEmitida(idPergunta: number){
    this.perguntaSelecionadaEmitida.emit(idPergunta);
  }

  private membroExcluidoRecebido(grupo: GrupoFamiliar){
    this.membroExcluidoEmitido.emit(grupo.id);
    this.carregaRespostas();
  }
  // mostra erros na tela
   private erro(erro: string): void{
     this.mensagem.open(erro, 'X', {duration: 5000});
     this.isLoading= false;
   }

   public proximo(){
     if(this.classProximo == ""){
       this.proximoEmitido.emit(4);
     }else{
       let confirmacao: Confirmacao = new Confirmacao("Você deve cadastrar " + this.quantidadeMembros + " membro(s) do grupo familiar para continuar", true);
       let dialogRef = this.dialog.open(ConfirmacaoDialog, {
           width: '400px',
           data: confirmacao,
         });

         dialogRef.afterClosed().subscribe(result => {
           if(result){
           }
         });
     }
   }

   public anterior(){
       this.anteriorEmitido.emit(4);
   }


   // finaliza o subscribe
   finaliza(): void{
     this.isLoading=false;
   }
}
